// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostBodyMessage-moduleNewsboardPostBodyMessage__nlMIm";
var _2 = "NewsboardPostBodyMessage-modulehoverableTitle__U1zt3";
var _3 = "NewsboardPostBodyMessage-modulelink__CCiLA";
var _4 = "NewsboardPostBodyMessage-modulemultiValuedList__lGD7W MultiValuedList-moduleMultiValuedList__ZJwbV";
var _5 = "NewsboardPostBodyMessage-moduletitle__EN5fH";
var _6 = "NewsboardPostBodyMessage-moduleunreadTitle__OB6T_";
export { _1 as "NewsboardPostBodyMessage", _2 as "hoverableTitle", _3 as "link", _4 as "multiValuedList", _5 as "title", _6 as "unreadTitle" }
